import React from 'react';
import { Form } from 'src/components/Antd';
import Co from 'src/constrains/AdvancedFilters/Collapse';
import { GeneralSelect } from 'src/constrains/AdvancedFilters/Components';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
const Item = Form.Item;
// // import { get } from 'lodash';
//import { formGetValue } from 'src/tools/helper';

const _GeneralSelect = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { form, name, defaultState, options, title, textPrefix, ...rest } =
    props;
  return (
    <Item
      noStyle
      shouldUpdate={(p, c) => {
        const touched = form.isFieldTouched(name);
        return touched; //|| cv !== pv;
      }}>
      {(f) => {
        const { getFieldValue } = f;
        const selectedUuid = getFieldValue(name) || [];
        const hasData = selectedUuid.length > 0;

        const selectedItems = selectedUuid.map((i) => {
          const item = options.find((option) => {
            return option.value === i;
          });
          if (item) {
            return item.label;
          }
          return '';
        });
        const textGenerator = () => {
          if (hasData) {
            return replaceI18nVariables(
              getI18n(`reports.reportdetailcomponents.filterSelect`),
              textPrefix || title,
              selectedItems.join(','),
            );
          }
          return '';
        };
        return (
          <Co
            header={title}
            displayText={textGenerator()}
            hasData={hasData}
            onClear={() => {
              //  console.log('name', name);
              form.setFieldsValue(defaultState);
            }}>
            <GeneralSelect {...rest} name={name} options={options} />
          </Co>
        );
      }}
    </Item>
  );
};
export default _GeneralSelect;
